var map = {
	"./denisa-gafova.jpg": 8022,
	"./jan-svoboda.jpg": 36785,
	"./kamila-pilna.jpg": 98216,
	"./karel-antos.jpg": 85368,
	"./lada-kosova.jpg": 58144,
	"./petr-jaros.jpg": 84648,
	"./quote.svg": 41538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42666;